import { render, staticRenderFns } from "./LectureVideoProcess.vue?vue&type=template&id=3d5dd332"
import script from "./LectureVideoProcess.vue?vue&type=script&lang=js"
export * from "./LectureVideoProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports